export const FRIENDS = [
  {
    "name": "La Voiture 4",
    "description": "Fanfare de poitevins exilés à Paris",
    "url": "http://voiture4.free.fr",
    "image": "voiture4.jpg"
  },
  {
    "name": "La Pustule",
    "description": "La fanfare qui décapsule !",
    "url": "http://pustule.org",
    "image": "pustule.jpg"
  },
  {
    "name": "Charlots d'Eon",
    "description": "Fanfare des Beaux Arts",
    "url": "http://charlotsdeon.org",
    "image": "charlots-deon.jpg"
  },
  {
    "name": "Les Chiures de Mouches",
    "description": "Fanfare étudiante de Poitiers",
    "url": "http://www.ordredubitard.fr",
    "image": "chiures.jpg"
  },
  {
    "name": "La Grasse Bande",
    "description": "Fanfare Disco Btp Disctinction...",
    "url": "http://www.lagrassebande.fr",
    "image": "grasse-bande.gif"
  },
  {
    "name": "Collectif Roger",
    "description": "Fanfare de Lyon aux relents de gin",
    "url": "https://www.facebook.com/CollectifRoger/",
    "image": "collectif-roger.jpg"
  },
  {
    "name": "Mouette et Charbons",
    "description": "Fanfare d'anciens lyonnais à Paris",
    "url": "http://mouetteetcharbons.tumblr.com",
    "image": "mouette-et-charbons.jpg"
  },
  {
    "name": "Fanfare Tractopelle",
    "description": "Fanfare rétro-futuriste-post-apocalyptique-dance-90's",
    "url": "https://www.facebook.com/fanfare.tractopelle/",
    "image": "tractopelle.jpg"
  }
]



/** WEBPACK FOOTER **
 ** ./src/data/friends.data.js
 **/